import { z } from 'my-zod'
import { orderPaymentSchema, orderRefundSchema } from './order-payment'
import { addOnDraft } from '../add-on'

export const updateCustomerOrderProductAddOnsSchema = z.object({
  customerOrderShortId: z.string(),
  orderTotalEstimate: z.number().nullable(),
  newPromotionDiscounts: z
    .object({
      promotion: z.object({
        id: z.string(),
        versionId: z.number(),
        code: z.string().nullable()
      }),
      discountId: z.string()
    })
    .array(),
  /** this is the amount the customer is paying "now" for the order update. If payment is "none", then paymentAmount should be zero  */
  settleAmount: z.number(),
  payment: orderPaymentSchema.optional(),
  refund: orderRefundSchema.optional(),
  addOns: addOnDraft.array(),
  originalCustomerInvoiceChecksum: z.string().min(1)
})

export type updateCustomerOrderProductAddOns = z.infer<typeof updateCustomerOrderProductAddOnsSchema>
